export const Account = () => ({
  showRecovery: false,
  showLogin: false,
  emailNotFound: false,
  init() {
    document.addEventListener('DOMContentLoaded', () => {
      if (window.location.hash === '#recover') {
        console.log(window.location)
        this.showRecovery = true;
      }
    });
  },
  recoverPassword() {
    this.emailNotFound = false;
    fetch('https://my.goodehealth.com/community/account/api/account/recover-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: this.$refs.emailInput.value })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.showRecovery = false;
          this.showLogin = true;
        } else {
          this.emailNotFound = true;
        }
      })
      .catch(error => console.error('Error:', error));
  }
});
